import { render, staticRenderFns } from "./ProjectClass.vue?vue&type=template&id=00401d75&scoped=true"
import script from "./ProjectClass.vue?vue&type=script&lang=js"
export * from "./ProjectClass.vue?vue&type=script&lang=js"
import style0 from "./ProjectClass.vue?vue&type=style&index=0&id=00401d75&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00401d75",
  null
  
)

export default component.exports